"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireDefault(require("react"));
var _fs = _interopRequireDefault(require("fs"));
var _replaceSpecialCharacters = _interopRequireDefault(require("../replaceSpecialCharacters"));
var dirPath = "/usr/src/app/log";
var createFolder = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _fs["default"].promises.mkdir(dirPath, {
              recursive: true
            });
          case 3:
            return _context.abrupt("return", {
              folderCreated: true
            });
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", {
              folderCreated: false
            });
          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6]]);
  }));
  return function createFolder() {
    return _ref.apply(this, arguments);
  };
}();
var writeFile = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(dirPath, newLogData) {
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return _fs["default"].promises.appendFile("".concat(dirPath), "".concat(newLogData));
          case 3:
            return _context2.abrupt("return", true);
          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0);
            console.log("Error on write file", dirPath, _context2.t0);
          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 6]]);
  }));
  return function writeFile(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
var checkIfFolderExists = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return _fs["default"].promises.access(dirPath);
          case 3:
            return _context3.abrupt("return", true);
          case 6:
            _context3.prev = 6;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", false);
          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 6]]);
  }));
  return function checkIfFolderExists() {
    return _ref3.apply(this, arguments);
  };
}();
var checkIfForbiddenUrlDirExists = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var forbiddenUrlExists;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return checkIfFolderExists();
          case 2:
            forbiddenUrlExists = _context4.sent;
            if (forbiddenUrlExists.isExist) {
              _context4.next = 7;
              break;
            }
            _context4.next = 6;
            return createFolder();
          case 6:
            return _context4.abrupt("return", _context4.sent);
          case 7:
            return _context4.abrupt("return", true);
          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function checkIfForbiddenUrlDirExists() {
    return _ref4.apply(this, arguments);
  };
}();
var writeLogToFile = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(logData) {
    var logFolderExists, currentDate, currentTime, dateAndTime, dateParts, month, day, fileName, newLogData;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return checkIfForbiddenUrlDirExists();
          case 2:
            logFolderExists = _context5.sent;
            if (!logFolderExists) {
              _context5.next = 14;
              break;
            }
            currentDate = new Date();
            currentTime = currentDate.toLocaleString("pl-PL", {
              timeZone: "Europe/Warsaw"
            });
            dateAndTime = currentTime.split(", ");
            dateParts = dateAndTime[0].split("/");
            month = dateParts[0].length === 1 ? "0".concat(dateParts[0]) : dateParts[0];
            day = dateParts[1].length === 1 ? "0".concat(dateParts[1]) : dateParts[1];
            fileName = "".concat(dateParts[2], "-").concat(month, "-").concat(day);
            newLogData = "[".concat(dateAndTime[1], "] ").concat(logData, " \r\n");
            _context5.next = 14;
            return writeFile("".concat(dirPath, "/").concat(fileName, ".log"), "".concat(newLogData));
          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function writeLogToFile(_x3) {
    return _ref5.apply(this, arguments);
  };
}();
var rewriteExceptionOnForbiddenUrl = function rewriteExceptionOnForbiddenUrl(ctx) {
  if (ctx.res) {
    ctx.res.writeHead(301, {
      Location: (0, _replaceSpecialCharacters["default"])(ctx.asPath)
    });
    ctx.res.end();
  }
};
var checkIfUrlIsForbidden = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(ctx) {
    var _ctx$req$headers$xRe, _ctx$req, _ctx$req$headers, _ctx$req2, _ctx$req2$headers, ip, _ctx$language, _ctx$language2;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!/"|\.js|\.json|script|<|'|>|`|\(|\)|\[|\]`/.test(ctx.asPath)) {
              _context6.next = 7;
              break;
            }
            if (ctx.asPath.includes("'")) {
              rewriteExceptionOnForbiddenUrl(ctx);
            }
            ip = (_ctx$req$headers$xRe = ctx === null || ctx === void 0 ? void 0 : (_ctx$req = ctx.req) === null || _ctx$req === void 0 ? void 0 : (_ctx$req$headers = _ctx$req.headers) === null || _ctx$req$headers === void 0 ? void 0 : _ctx$req$headers["x-real-ip"]) !== null && _ctx$req$headers$xRe !== void 0 ? _ctx$req$headers$xRe : ctx === null || ctx === void 0 ? void 0 : (_ctx$req2 = ctx.req) === null || _ctx$req2 === void 0 ? void 0 : (_ctx$req2$headers = _ctx$req2.headers) === null || _ctx$req2$headers === void 0 ? void 0 : _ctx$req2$headers["x-forwarded-for"];
            if (process.browser) {
              _context6.next = 6;
              break;
            }
            _context6.next = 6;
            return writeLogToFile("".concat(ctx.asPath, " ").concat((_ctx$language = ctx.language) === null || _ctx$language === void 0 ? void 0 : _ctx$language.domain, " ").concat((_ctx$language2 = ctx.language) === null || _ctx$language2 === void 0 ? void 0 : _ctx$language2.language, " ").concat(ip));
          case 6:
            return _context6.abrupt("return", true);
          case 7:
            return _context6.abrupt("return", false);
          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return function checkIfUrlIsForbidden(_x4) {
    return _ref6.apply(this, arguments);
  };
}();
var _default = checkIfUrlIsForbidden;
exports["default"] = _default;